module.exports = __webpack_public_path__ + "img/png-file-icon-6.54eb6ec9.jpg";